// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falArrowTrendDown: CreateIconOptions = {
  "displayName": "FALArrowTrendDown",
  "viewBox": "0, 0, 576, 512",
  "d": "M368 400c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16l0-176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 137.4L331.3 148.7c-6.2-6.2-16.4-6.2-22.6 0L192 265.4 27.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0L320 182.6 521.4 384 384 384c-8.8 0-16 7.2-16 16z"
};
